import { Select } from "@mantine/core"
import { useGetLocationsSuspense } from "@/orval/gen"
import { useTranslation } from "react-i18next"

export function LocationSelect({
  value,
  onChange,
  error,
  placeholder,
  required,
}: {
  value: string | null
  onChange: (v: string | null) => void
  error?: React.ReactNode
  placeholder?: string
  required?: boolean
}) {
  const [search, setSearch] = React.useState("")
  const { data: allLocations } = useGetLocationsSuspense()
  const { t } = useTranslation("app_server")

  const options = React.useMemo(() => {
    if (!allLocations) return []

    const filtered = search.trim()
      ? allLocations.filter(
          (loc) =>
            (loc.name?.toLowerCase().includes(search.toLowerCase()) ?? false) ||
            (loc.shortName?.toLowerCase().includes(search.toLowerCase()) ??
              false)
        )
      : allLocations

    return filtered.map((loc) => ({
      value: String(loc.locationId),
      label: `${loc.name}${loc.shortName ? ` (${loc.shortName})` : ""}`,
    }))
  }, [allLocations, search])

  return (
    <Select
      label={t("Location")}
      searchable
      clearable
      data={options}
      value={value}
      onChange={onChange}
      searchValue={search}
      onSearchChange={setSearch}
      error={error}
      placeholder={placeholder}
      required={required}
      nothingFoundMessage={t("NoLocationFound")}
    />
  )
}
